import { Header2 } from '@cian/ui-kit/typography/Header';
import { InlineText1 } from '@cian/ui-kit/typography/InlineText';

import * as React from 'react';

import * as styles from './ModalContentStageFilling.css';
import { IModalContentStageFillingProps } from './types';

export const ModalContentStageFilling: React.FC<IModalContentStageFillingProps> = props => {
  const { description, title, children } = props;

  return (
    <div>
      <div className={styles['title-container']}>
        <Header2 as="span" color="black_100" fontWeight="bold">
          {title}
        </Header2>
      </div>
      <InlineText1 as="span" color="black_100" fontWeight="normal">
        {description}
      </InlineText1>
      <div className={styles['form-container']}>{children}</div>
    </div>
  );
};

ModalContentStageFilling.displayName = 'ModalContentStageFilling';
